import { Component, OnInit } from '@angular/core';
import { DistributionHeaderComponent } from '../abstract-header/distribution-header.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { InsignDistributionJob, InsignState } from '../../../models/distribution-doc-models';
import { InSignEmailDistributionDialogComponent } from '../insign-email-distribution-dialog/insign-email-distribution-dialog.component';
import { InSignSMSDistributionDialogComponent } from '../insign-sms-distribution-dialog/insign-sms-distribution-dialog.component';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';

@Component({
    selector: 'insign-distribution-header',
    templateUrl: './insign-distribution-header.component.html',
    styleUrls: ['./insign-distribution-header.component.scss']
})
export class InSignDistributionHeaderComponent extends DistributionHeaderComponent<InsignDistributionJob>
                                               implements OnInit {

    public noToSelectionError: boolean;
    public emailToError: boolean;
    public smsToError: boolean;
    public periodError: boolean;

    get job(): InsignDistributionJob {
        return this.bananaBox;
    }

    get InsignState() {
        return InsignState;
    }

    constructor(public dialog: MatDialog) {
        super();
        this._idPrefix = 'insign.'
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public setSignNowOption(value: boolean): void {
        const opData: OpData[] = [{
            op: OP.replace,
            path: 'insign_send_now',
            value: value
        }];

        if (value) {
            if (this.job.insign_send_email) {
                opData.push({
                    op: OP.remove,
                    path: 'insign_send_email'
                });

                opData.push({
                    op: OP.remove,
                    path: 'insign_email_to'
                });
            }

            if (this.job.insign_send_sms) {
                opData.push({
                    op: OP.remove,
                    path: 'insign_send_sms'
                });

                opData.push({
                    op: OP.remove,
                    path: 'insign_sms_to'
                });
            }
        }

        this.onMultiUpdate(opData);
    }

    public setEmailOption(value: boolean): void {
        this.noToSelectionError = !value && !this.job.insign_send_sms;

        if (value) {
            if (!this.job.insign_email_to && this.job.receiver && this.job.receiver.address && this.job.receiver.address.email) {
                this.job.insign_email_to = this.job.receiver.address.email;

                const opData = [{
                    op: OP.replace,
                    path: 'insign_send_email',
                    value: value
                }, {
                    op: OP.replace,
                    path: 'insign_email_to',
                    value: this.job.insign_email_to
                }];

                this.onMultiUpdate(opData);
            } else {
                this.onChange('insign_send_email', value);
            }

            this.editEmailDistribution();
        } else {
            this.onChange('insign_send_email', value);
        }
    }

    public setSMSOption(value: boolean): void {
        this.noToSelectionError = !this.job.insign_send_email && !value;

        if (value) {
            if (!this.job.insign_sms_to && this.job.receiver && this.job.receiver.address && (this.job.receiver.address.phone || this.job.receiver.address.phone2)) {
                this.job.insign_sms_to = this.job.receiver.address.phone || this.job.receiver.address.phone2;

                const opData = [{
                    op: OP.replace,
                    path: 'insign_send_sms',
                    value: value
                }, {
                    op: OP.replace,
                    path: 'insign_sms_to',
                    value: this.job.insign_sms_to
                }];

                this.onMultiUpdate(opData);
            } else {
                this.onChange('insign_send_sms', value);
            }

            this.editSMSDistribution();
        } else {
            this.onChange('insign_send_sms', value);
        }
    }

    public editEmailDistribution(): void {
        const dialogRef = this.dialog.open(InSignEmailDistributionDialogComponent, {
            width: '80%',
            data: new InsignDistributionJob(this.job)
        });

        dialogRef.afterClosed()
                 .subscribe((dialogResult: InsignDistributionJob) => {
                     if (dialogResult) {

                         const opData = [{
                             op: OP.replace,
                             path: 'insign_email_to',
                             value: dialogResult.insign_email_to
                         }, {
                             op: OP.replace,
                             path: 'insign_email_subject',
                             value: dialogResult.insign_email_subject
                         }, {
                             op: OP.replace,
                             path: 'insign_email_body_before_link',
                             value: dialogResult.insign_email_body_before_link
                         }, {
                             op: OP.replace,
                             path: 'insign_email_body_after_link',
                             value: dialogResult.insign_email_body_after_link
                         }];

                         this.validateEmailOptions(dialogResult);
                         this.onMultiUpdate(opData);
                     } else if (!this.job.insign_email_to ||
                                !this.job.insign_email_subject ||
                               (!this.job.insign_email_body_before_link && !this.job.insign_email_body_after_link)) {
                         this.onChange('insign_send_email', false);
                     }
                 });
    }

    public editSMSDistribution(): void {
        const dialogRef = this.dialog.open(InSignSMSDistributionDialogComponent, {
            width: '80%',
            data: new InsignDistributionJob(this.job)
        });

        dialogRef.afterClosed()
                 .subscribe((dialogResult: InsignDistributionJob) => {
                     if (dialogResult) {
                         const opData = [{
                             op: OP.replace,
                             path: 'insign_sms_to',
                             value: dialogResult.insign_sms_to
                         }, {
                             op: OP.replace,
                             path: 'insign_sms_body',
                             value: dialogResult.insign_sms_body
                         }];

                         this.validateSMSOptions(dialogResult);
                         this.onMultiUpdate(opData);
                     } else if (!this.job.insign_sms_to || !this.job.insign_sms_body) {
                         this.onChange('insign_send_sms', false);
                     }
                 });
    }

    public onPeriodChange(hours: number): void {
        if (hours) {
            this.periodError = false;
        }

        this.onChange('insign_session_valid_for_hours', hours);
    }

    public validate(): boolean {
        this.noToSelectionError = !this.job.insign_send_email && !this.job.insign_send_sms && !this.job.insign_send_now;
        this.periodError = !this.job.insign_session_valid_for_hours && !this.job.insign_send_now;

        this.validateEmailOptions(this.job);
        this.validateSMSOptions(this.job);

        return !this.noToSelectionError && !this.smsToError && !this.emailToError && !this.periodError;
    }

    private validateEmailOptions(job: InsignDistributionJob): void {
        this.emailToError = !this.job.insign_send_now &&
                            job.insign_send_email &&
                            (!job.insign_email_to ||
                             !job.insign_email_subject ||
                             (!job.insign_email_body_before_link && !job.insign_email_body_after_link));
    }

    private validateSMSOptions(job: InsignDistributionJob): void {
        this.smsToError = !this.job.insign_send_now &&
                          job.insign_send_sms &&
                          (!job.insign_sms_to || !job.insign_sms_body);
    }

    public isValid(): boolean {
        return true;
    }
}
